<h2 class="header">
  <span class="title">Extract timeseries data: <b>{{ datasetName }}</b></span>
  <button mat-icon-button mat-dialog-close><mat-icon svgIcon="close"></mat-icon></button>
</h2>

<div mat-dialog-content>
  <ng-container *ngIf="!extractionStarted">
    <div class="selection-row" *ngIf="isLoaded" [formGroup]="timeseriesParameterSelectionForm">
      <div class="period">
        <!-- <div>Select time period to extract</div> -->
        <div class="start-calendar">
          <label>Select the first date</label>
          <mat-calendar [dateFilter]="timeseriesFilter" [minDate]="minDate" [maxDate]="maxDate" [startAt]="minDate"
            [selected]="startDateControl.value" (selectedChange)="updateFormStartDate($event)"></mat-calendar>
        </div>
        <mat-divider vertical class="period-divider"></mat-divider>
        <div class="end-calendar">
          <label>Select the last date</label>
          <mat-calendar [dateFilter]="timeseriesFilter" [minDate]="minDate" [maxDate]="maxDate" [startAt]="maxDate"
            [selected]="endDateControl.value" (selectedChange)="updateFormEndDate($event)"></mat-calendar>
        </div>
      </div>

      <mat-divider vertical></mat-divider>

      <div class="inputs">
        <mat-form-field appearance="outline">
          <mat-label>Vector layer</mat-label>
          <mat-select formControlName="vector_layers" multiple>
            <mat-option *ngFor="let layer of vectorLayers" [value]="layer.unique_id">{{ layer.visibleLayerName
              }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Stats</mat-label>
          <mat-select formControlName="stats" multiple>
            <mat-option *ngFor="let stat of stats" [value]="stat" [disabled]="statsDisabled[stat]">{{ stat | statsName }}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="spacer"></div>

        <div>
          <ng-container *ngIf="timeseriesParameterSelectionForm.valid">
            You are about to extract <b>{{ amoutOfCalculations }}</b> calculations, this might take some time.
            <!-- TODO: Give indication on how much time -->
          </ng-container>
        </div>

        <button mat-raised-button [disabled]="timeseriesParameterSelectionForm.invalid || amoutOfCalculations === 0"
          (click)="generateTableStructure()">
          Start data extraction
        </button>
      </div>
    </div>
  </ng-container>


  <div class="extraction-result" *ngIf="(dataSource.extractionState | async) as extractionState">
    <mat-progress-bar mode="buffer" [value]="dataSource.progress" [bufferValue]="dataSource.bufferProgress">
    </mat-progress-bar>

    <div class="extraction-state" [ngSwitch]="extractionState">
      <div class="initializing" *ngSwitchCase="'initializing'">
        Please wait, the extraction process is starting up.
      </div>

      <div class="calculating" *ngSwitchCase="'calculating'">
        <ng-container *ngIf="(progressObservableObject | async) as progressObject">
          Extraction started at <b>{{ dataSource.startTime | date : 'HH:mm:ss' }}</b>, estimated extraction will be
          finished at <b>{{ progressObject.estimatedEndTime | date : 'HH:mm:ss' }}</b> (<b>{{
            progressObject.estimatedTimeLeft }}</b> remaining).
          <p>
            <b>{{ progressObject.finishedDataPoints }}</b> out of <b>{{ dataSource.totalDataPoints }}</b> calculations
            finished (<b>{{ progressObject.progress }}%</b>).
            Calculation has been running for <b>{{ progressObject.timeRunning }}</b>, on average {{
            progressObject.calculationsPerSecond }} calculations are done per second.
          </p>
        </ng-container>
      </div>

      <div class="finished" *ngSwitchCase="'finished'">
        Extraction finished, You can now download this data or send it to EDE for additional analysis.

        <div class="spacer"></div>

        Extraction started at <b>{{ dataSource.startTime | date : 'HH:mm:ss' }}</b>, finished at <b>{{
          dataSource.endTime | date : 'HH:mm:ss' }}</b>.
        <b>{{ dataSource.totalDataPoints }}</b> calculations done in <b>{{ dataSource.finalCalculationTime }}</b>.


        <div class="export-buttons">
          <div class="spacer"></div>
          <button mat-raised-button (click)="exportData()" [disabled]="(exporting | async)">
            <mat-icon svgIcon="download-outline"></mat-icon>
            Download as CSV
          </button>
          <div class="spacer"></div>

          <button mat-raised-button (click)="sendToEde()" [disabled]="(exporting | async)">
            <mat-icon svgIcon="download-outline"></mat-icon>
            Visualise in EDE
          </button>
          <div class="spacer"></div>
        </div>

        <ng-container *ngIf="(exporting | async)">
          <div class="export-progress">
            <div class="spacer"></div>
            <div class="progress">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              <div>Exporting in progress</div>
            </div>
            <div class="spacer"></div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
